<template>
  <v-dialog
      v-model="dialog"
      max-width="400"
    >
      <v-card>
        <v-card-title>
          {{ $t('Confirm') }}
        </v-card-title>
        <v-card-text>
          {{ $t('Are you sure to delete?') }}
          <div>{{ item.code || item.name || item.title || '' }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            @click="no($event)"
          >
            {{ $t('No') }}
          </v-btn>
          <v-btn
            color="red"
            dark
            @click="yes($event)"
          >
            {{ $t('Yes') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'DialogDelete',
  data() {
    return {
      dialog: false,
      item: {}
    }
  },
  methods: {
    confirm(item) {
      this.dialog = true
      this.$set(this, 'item', item)
    },

    yes(e) {
      e.preventDefault()
      this.dialog = false
      this.$emit('yes', this.item)
    },

    no(e) {
      e.preventDefault()
      this.dialog = false
      this.$set(this, 'item', {})
    }
  }
}
</script>
